"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPOR_API_KEY = exports.SUPPORT_APP = exports.AMONSUL_API = void 0;
exports.AMONSUL_API = 'https://amonsul.douban.com/';
var SUPPORT_APP;
(function (SUPPORT_APP) {
    SUPPORT_APP["Frodo_iOS_H5"] = "Frodo_iOS_H5";
    SUPPORT_APP["Frodo_Android_H5"] = "Frodo_Android_H5";
    SUPPORT_APP["Web_H5"] = "Web_H5";
})(SUPPORT_APP = exports.SUPPORT_APP || (exports.SUPPORT_APP = {}));
var SUPPOR_API_KEY;
(function (SUPPOR_API_KEY) {
    SUPPOR_API_KEY["Frodo_iOS_H5"] = "41149c4820423a8757c1cb1ebda8fab3c";
    SUPPOR_API_KEY["Frodo_Android_H5"] = "55a4cb10cf36d201fec31696c2652204b";
    SUPPOR_API_KEY["Web_H5"] = "d7843dd4f47837b166aedc76030951f4a";
})(SUPPOR_API_KEY = exports.SUPPOR_API_KEY || (exports.SUPPOR_API_KEY = {}));
//# sourceMappingURL=const.js.map